'use strict';

import { Injectable, Inject } from 'ng-metadata/core';
import {getVid} from '../../appConfig/appConfigForward';
import {Cheetah} from '../../search/cheetah.service';


let intersection = require('lodash/intersection');
let keys = require('lodash/keys');
let isEmpty = require('lodash/isEmpty');

@Injectable()
export class SavedQueriesService{
    unlabeled: Number;
    labels: Object[];
    records: Object[];
    items: Array<SavedQueryItem>;//the displayed items, used for infinite scrolling 
    totalItems: Array<SavedQueryItem> = [];//used for infinite scrolling 
    numberOfItemsToDisplay: number = 10;
    sortedLabels: Object[];
    private GET_URL:string;
    favoritesInProgress: boolean = false;
    unlabeledRecords: boolean = false;
    private isFirstBulk: boolean = true;
    needToChangeUrl: boolean = false;
    allItems: boolean = false;
    _user: boolean = false;
    firstBulk: number = 0;
    countRecords: number = 0;
    bulkSize: number = 10;
    private fullList: Object[];
    selectedLabels: string[];
    private vid:string= getVid();

    constructor(private cheetahService:Cheetah,
                @Inject('$http') private $http : angular.IHttpService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$stateParams') private $stateParams : ng.ui.IStateParamsService,
                @Inject('restBaseURLs') private restBaseURLs,
                ) {
        this.GET_URL= restBaseURLs.saveSearchURL;

    }

    getItemsFromApi(){
        
          return this.makeRequest('get', null,'GET', '?vid=' + getVid())
                .then((res: IApiQueryList) =>{
                    console.log('entire res:' + JSON.stringify(res));
                    this.totalItems= [];
                    this.items= [];
                    for(let item of res.searchesList){
                        //this.items.push(new SavedQueryItem(item)); 
                        this.totalItems.push(new SavedQueryItem(item));
                    }
                    if(!this.isFirstBulk){
                        this.refreshItems();
                    }
                    else{    
                        this.isFirstBulk = false;
                        this.resetItems();
                    }
                }, (reason) => {
                    console.log('get searches failed: ',reason);
                });

    }

    get Items(){
        return this.items;
    }

    setItems(_items){
        return this.items=_items;
    }
    
    
    /*
    returns the next none displayed bulk of search history items,
    to display them in an infinite scroll
    */
    public nextResults() {
     let itemsToAdd = Math.min(this.bulkSize,this.totalItems.length-this.numberOfItemsToDisplay);//for the the last bulk
        if (itemsToAdd > 0) {
           this.numberOfItemsToDisplay += itemsToAdd;
           this.items = this.totalItems.slice(0,this.numberOfItemsToDisplay);//add to items the next none displayed bulk of search history items
            if (itemsToAdd < this.bulkSize) {
               this.allItems = true;
           }
        }
        else
        {
            this.allItems = true;
        }
     }
    
    /*
    returns true if has More not displayed Results
    */
    public hasNextResults() {
        return (!this.allItems && (this.totalItems.length > this.bulkSize));
    }
    
    /*
    assign to items, the number of items to display.
    */
    public refreshItems(){
        this.items = this.totalItems.slice(0,this.numberOfItemsToDisplay);
    }
    
    /*
    assign to items, the bulk size number of items to display.
    */
    public resetItems(){
        this.allItems = false;
        this.numberOfItemsToDisplay = this.bulkSize;
        this.items = this.totalItems.slice(0,this.numberOfItemsToDisplay);
    }
    
    private calculatePayload(queryUrl, email){
        let payload = {'add':[{'searchData':this.cheetahService.searchData,'queryUrl':queryUrl, 'email':email}] };
        return payload; 
    }
    
    public makeRequest(serviceName: string, params: Object = null, method: string = null, suffixPath:string = '') {
        
        let httpConfig = {
            method: method,
            url: this.GET_URL + suffixPath,
            params: method === 'GET' ? params : null,
            data: (method === 'POST' || method === 'PUT') ? params : null
        };

        return this.$http(httpConfig)
            .then(
                (response)=> this.reqSuccess(response.data),
                (error)=>this.reqFailure(error, serviceName, params)
            );
    }
    
    public removeSearch(searchId: string){
        let payload = {'ids':[{'id':searchId}]};
        return this.makeRequest('remove', payload,'POST', '/remove?vid=' + getVid());
    }
    
    public removeSelectedSearches(){
        let selectedSearches= this.getCheckedItems();
        let payload= {'ids': []};
        for (let search of selectedSearches){
            payload.ids.push({'id':search.ID});
        }
        return this.makeRequest('remove', payload,'POST', '/remove?vid=' + getVid());
    }
    
    public updateAlerts(item: SavedQueryItem, email: string){
        let searchId = item.ID;
        let isAlert = (item.alert?0:1);
        let payload = {'ids':[{'id':searchId}], 'isAlert': isAlert, 'email':email};
        return this.makeRequest('update', payload,'PUT', '?vid=' + getVid());
    }

    public createRSS(item: SavedQueryItem){
        let searchId = item.ID;
        let payload = {'ver': '2_1_4', 'gatherpagestat':'true', 'EXLTabBoomId':'xxxxx', 'boombaseurl':'https://beacon01.alma.exlibrisgroup.com/boom/apache_pb.gif', 'encCtxt': item.encCtxt, 'sr':item.sr};
        let url='/primo_library/libweb/action/../newRss?rssId='+searchId+'&amp;ver=2_1_4';
        let configParams = {params: payload};
        return this.$http.post(url, payload,configParams);            
            

        
    }

    
    

    public setAlertToSelectedSearches(email: string, selectedIds ?: Array<string>){
        email= email? email : ''; 
        selectedIds= selectedIds? selectedIds : this.getCheckedItems().map((item)=>{return item.ID});
        let payload= {'ids':[], 'isAlert': 1, 'email':email};
        for (let id of selectedIds){
            payload.ids.push({'id':id});
        }
        return this.makeRequest('update', payload,'PUT', '?vid=' + getVid());        
    }
    
    private reqSuccess(response){
        
        return response;
    }

    private reqFailure(reason, serviceName, params){
        
        throw reason;
    }
    
    public getCheckedItems(){
        if(!this.items){
            return [];
        }
        return this.items.filter((item)=>{return item.checked});
    }    

}

export interface IApiQueryList{
    searchesList: Array<IApiQueryItem>;
}

export interface IApiQueryItem{
    ID: number;
    alert: boolean;
    creationDate: string;
    deepLink: string;
    email ?: string;
    mode: string;
    query: string;
    scope: string;
    tab: string;
    pfilter:string;
    facet:string;
    cheetahSearchData:any;// used in search history
	sr: string;
	encCtxt:string;
    rsscreated:boolean;
}

export class SavedQueryItem implements IApiQueryItem{
    public ID: number;
    public alert: boolean;
    public creationDate: string;
    public deepLink: string;
    public email: string;
    public mode: string;
    public query: string;
    public scope: string;
    public tab: string;
    public checked: boolean;
    public pfilter: string;
    public facet: string;
    public cheetahSearchData: any;
	public sr: string;
	public encCtxt:string;
	public rsscreated:boolean;
    
    constructor(apiSearchItem: IApiQueryItem){
        this.ID = apiSearchItem.ID;
        this.alert = apiSearchItem.alert;
        this.creationDate = apiSearchItem.creationDate;
        this.deepLink = apiSearchItem.deepLink;
        this.email= apiSearchItem.email;
        this.mode = apiSearchItem.mode;
        this.query = apiSearchItem.query;
        this.scope = apiSearchItem.scope;
        this.tab = apiSearchItem.tab;
        this.checked= false;
        this.pfilter = apiSearchItem.pfilter;
        this.facet = apiSearchItem.facet;
        this.cheetahSearchData = apiSearchItem.cheetahSearchData;
        this.sr = apiSearchItem.sr;
        this.encCtxt = apiSearchItem.encCtxt;
        this.rsscreated = apiSearchItem.rsscreated;
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/components/favorites/savedQueries/savedQueries.service.ts